import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuIcon from "@mui/icons-material/Menu";
import { SessionContext } from "../context/sessionContext";
import SettingsModal from "./SettingsModal";
import { Settings, User, LogOut } from "lucide-react";
import { useUser } from "../context/UserContext"; 

export default function Navbar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const { isAuthenticated, logout, session } = useContext(SessionContext);
  const { userData, profilePicUrl, isAdmin, roleName, getInitials } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate("/");
    }
  };
  const handleSettingsClick = () => {
    setShowProfileDropdown(false);
    if (isAdmin) {
      navigate("/profile");
    } else {
      setShowSettingsModal(true);
    }
  };
  const username = userData?.username ||"User";
  const initials = getInitials();
  return (
    <>
      <div
        className={`navbar-overlay ${isDrawerOpen ? "active" : ""}`}
        onClick={() => setIsDrawerOpen(false)}
      ></div>
      <nav className="navbar">
        <div className="navbar-container">
          <div>
            <div className="navbar-logo">
              <Link to="/">
                <img
                  alt="Generative Insight"
                  src="/json-media/icons/GI-logo.svg"
                />
              </Link>
            </div>
          </div>
          <div
            className="navbar-toggle"
            onClick={() => setIsDrawerOpen(true)}
            aria-label="Open navigation"
          >
            <MenuIcon style={{ color: "#fff", fontSize: 30 }} />
          </div>
          <div className="navbar-links web-view-only">
            <ul>
            
                <li>
                  <Link
                    to="/"
                    className={location.pathname === "/" ? "active-nav" : ""}
                  >
                    Home
                  </Link>
                </li>
              <li>
                <Link
                  to="/solution"
                  className={
                    location.pathname === "/solution" ? "active-nav" : ""
                  }
                >
                  Solution
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className={location.pathname === "/pricing" ? "active-nav" : ""}
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className={
                    location.pathname === "/how-it-works" ? "active-nav" : ""
                  }
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className={location.pathname === "/about" ? "active-nav" : ""}
                >
                  About Us
                </Link>
              </li>
            </ul>
          </div>

         <div className="navbar-cta web-view-only">
            {!isAuthenticated && (
              <Link to="/log-in">
                <button className="navbar-btn-secondary">Log In</button>
              </Link>
            )}

            {isAuthenticated ? (
              <Link to="/projects">
                <button className="navbar-btn-primary">View Projects</button>
              </Link>
            ) : (
              <Link to="/create-survey">
                <button className="navbar-btn-primary">Get Started</button>
              </Link>
            )}

            {isAuthenticated && (
              <div className="navbar-profile-container">
                {profilePicUrl ? (
                  <img
                    src={profilePicUrl}
                    alt="profile"
                    className="navbar-profile"
                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  />
                ) : (
                  <div
                    className="navbar-profile-initials"
                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  >
                    {initials}
                  </div>
                )}

                {showProfileDropdown && (
                  <div className="navbar-profile-dropdown">
                    <div className="navbar-dropdown-header">
                      <div className="navbar-dropdown-info">
                        <div className="navbar-dropdown-name">{username}</div>
                        {roleName && (
                          <div className="navbar-dropdown-role">{roleName}</div>
                        )}
                      </div>
                    </div>
                    <div className="navbar-dropdown-divider"></div>
                    <button
                      onClick={handleSettingsClick}
                      className="navbar-dropdown-btn"
                    >
                      <Settings size={16} />
                      <span>Settings</span>
                    </button>
                    <button onClick={handleLogout} className="navbar-dropdown-btn logout">
                      <LogOut size={16} />
                      <span>Log Out</span>
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </nav>

      <div className="mobile-view ">
        <div className={`navbar-drawer ${isDrawerOpen ? "active" : ""}`}>
          <div className="drawer-header">
            <CloseRoundedIcon
              onClick={() => setIsDrawerOpen(false)}
              className="drawer-close"
            />
          </div>
          <div className="nav-drawer-links">
            <Link to="/" onClick={() => setIsDrawerOpen(false)}>
              Home
            </Link>
            <Link to="/solution" onClick={() => setIsDrawerOpen(false)}>
              Solution
            </Link>
            <Link to="/pricing" onClick={() => setIsDrawerOpen(false)}>
              Pricing
            </Link>
            <Link to="/how-it-works" onClick={() => setIsDrawerOpen(false)}>
              How It Works
            </Link>
            <Link to="/about" onClick={() => setIsDrawerOpen(false)}>
              About Us
            </Link>
          </div>
          <div className="navbar-drawer-cta">
            {!isAuthenticated && (
              <>
                <Link to="/log-in" onClick={() => setIsDrawerOpen(false)}>
                  <button className="navbar-btn-secondary">Log In</button>
                </Link>
                <Link to="/create-survey" onClick={() => setIsDrawerOpen(false)}>
                  <button className="navbar-btn-primary">Get Started</button>
                </Link>
              </>
            )}
            {isAuthenticated && (
              <>
                <Link to="/projects" onClick={() => setIsDrawerOpen(false)}>
                  <button className="navbar-btn-primary">Projects</button>
                </Link>
                <button className="navbar-btn-secondary" onClick={handleLogout}>
                  Log Out
                </button>
              </>
            )}
          </div>
        </div>
      </div>
     <SettingsModal
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        onLogout={handleLogout}
      />
    </>
    
  );
}
